<template>
    <div>
        <pagamento-detalhar
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            :mostrarTimeLine="exibirTimeline"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        >
            <template slot="mensagem">
                <slot name="mensagem"></slot>
            </template>
            <template slot="footer" slot-scope="data">
                <app-btn-voltar></app-btn-voltar>
                <btn-certidoes
                    class="ml-2"
                    :pagamento="pagamento"
                    :servicos="pagamentosServicos"
                ></btn-certidoes>
                <pagamento-enviar-para-analise
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                ></pagamento-enviar-para-analise>
                <btn-solicitar-autorizacao-envio-fora-do-prazo
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                >
                </btn-solicitar-autorizacao-envio-fora-do-prazo>
                <pagamento-aprovar-reprovar
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                ></pagamento-aprovar-reprovar>
                <b-button
                    variant="primary"
                    class="ml-2"
                    @click.stop="mostrarAnexos = true"
                    v-if="$temAcessoView('GESCON-UFI-PAG-04') && !mostrarAnexos"
                    ><i class="fa fa-paperclip"></i> Documentos</b-button
                >
                <btn-exportar
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    class="ml-2"
                ></btn-exportar>
                <slot name="finalizacaoFooter" v-bind="data"></slot>
                <b-button
                    variant="primary"
                    class="ml-2 mr-1"
                    @click.stop="mostrarTimeline()"
                    >{{ textoBtnTimeline }} Timeline</b-button
                >
            </template>
        </pagamento-detalhar>
        <pagamento-anexos2
            v-if="$temAcessoView('GESCON-UFI-PAG-04') && mostrarAnexos"
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            @fechar="mostrarAnexos = false"
        ></pagamento-anexos2>
        <pagamento-comprometimentos
            :comprometimentos="pagamento.comprometimentos"
            :pagamentosServicos="pagamentosServicos"
            :incluirSelecao="false"
            :isPagamento="true"
        >
            <template slot="botoes">
                <slot name="comprometimentosBotoes"></slot>
            </template>
            <template slot="comprometimentoAcoes" slot-scope="data">
                <slot name="comprometimentoAcoes"></slot>
                <pagamento-desassociar-comprometimento
                    :pagamento="pagamento"
                    :pagamentoComprometimento="data"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="mr-1"
                    v-if="mostrarBtnDesassociarComprometimento"
                ></pagamento-desassociar-comprometimento>
            </template>
        </pagamento-comprometimentos>
        <pagamento-anexos
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        ></pagamento-anexos>
        <b-card no-body>
            <b-card-body>
                <app-btn-voltar></app-btn-voltar>
                <pagamento-enviar-para-analise
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                ></pagamento-enviar-para-analise>
                <btn-solicitar-autorizacao-envio-fora-do-prazo
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                >
                </btn-solicitar-autorizacao-envio-fora-do-prazo>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import PagamentoDetalhar from './PagamentoDetalhar'
import PagamentoComprometimentos from './PagamentoComprometimentos'
import PagamentoAnexos from './PagamentoAnexos'
import PagamentoAnexos2 from './PagamentoAnexos2'
import { pagamentoStatus } from './PagamentoStatus'
import PagamentoDesassociarComprometimento from './PagamentoDesassociarComprometimento'
import PagamentoEnviarParaAnalise from './PagamentoEnviarParaAnalise'
import PagamentoAprovarReprovar from './PagamentoAprovarReprovar'
import BtnSolicitarAutorizacaoEnvioForaDoPrazo from './BtnSolicitarAutorizacaoEnvioForaDoPrazo'
import BtnCertidoes from './BtnCertidoes'
import BtnExportar from './BtnExportar'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            mostrarAnexos: false,
            textoBtnTimeline: 'Exibir',
            exibirTimeline: false
        }
    },

    methods: {
        obterPagamentoAtualizado() {
            this.$emit('obterPagamentoAtualizado')
        },
        mostrarTimeline() {
            this.exibirTimeline = !this.exibirTimeline
            if (!this.exibirTimeline) {
                this.textoBtnTimeline = 'Exibir'
            } else {
                this.textoBtnTimeline = 'Ocultar'
            }
        }
    },

    computed: {
        mostrarBtnDesassociarComprometimento() {
            return (
                (this.pagamento.status === pagamentoStatus.CRIADO ||
                    this.pagamento.status === pagamentoStatus.REPROVADO) &&
                this.$temAcesso('GESCON-FORN-PAG-03')
            )
        }
    },

    components: {
        PagamentoDetalhar,
        PagamentoComprometimentos,
        PagamentoAnexos,
        PagamentoAnexos2,
        PagamentoDesassociarComprometimento,
        PagamentoEnviarParaAnalise,
        PagamentoAprovarReprovar,
        BtnSolicitarAutorizacaoEnvioForaDoPrazo,
        BtnCertidoes,
        BtnExportar
    }
}
</script>
